module.exports = __webpack_public_path__ + "static/media/10.55a017e9.jpg";